module.exports = __webpack_public_path__ + "media/最好的生活 (电影《我要我们在一起》配乐).c09c17e7.mp3";